/** Hebrew tooltip texts for journey builder stages */

export const workflowCanvasHelp = `מדריך עבודה בלוח הג'ירני:

• לחץ וגרור צמתים כדי לשנות את מיקומם
• לחץ וגרור את הרקע כדי לנוע בלוח
• החזק Shift וגרור כדי לבחור מספר צמתים
• החזק Ctrl וגלול כדי לשנות זום
• לחץ על צומת כדי לערוך את ההגדרות שלו
• לחץ על + על קו החיבור כדי להוסיף שלב חדש
• לחץ Save לשמירת השינויים

בניית ג'ירני:
1. בחר טריגר (שלב ראשון) — מה מפעיל את התהליך
2. הוסף פעולות — שליחת הודעות, המתנה, שאילתות SQL ועוד
3. הוסף תנאים — לפצל את הנתיב לפי כללים (כן/לא)
4. חבר את הצמתים וודא שכל ענף מסתיים ב-Exit`;

export const sectionTooltips = {
  pipeBuilder:
    "בנה שאילתת SQL ויזואלית לבחירת לידים. הגדר טבלאות, שדות, אופרטורים ותנאים. לחץ Run Query לבדיקת התוצאות לפני שמירה. ניתן לשמור שאילתה לשימוש חוזר.",
  conditionBuilder:
    "הגדר תנאים לפיצול הנתיב. Include All = הליד חייב לעמוד בכל התנאים. Exclude All = הליד נפסל אם עומד בכל התנאים. כל תנאי בודק שדה מטבלת הלידים.",
  includeExcludeToggle:
    "Include All — הליד עובר רק אם עומד בכל התנאים.\nExclude All — הליד נפסל אם עומד בכל התנאים.",
  addFirstStep:
    "לחץ כאן כדי לבחור את שלב הפתיחה (טריגר) — האירוע שמפעיל את הג'ירני. לדוגמה: ליד חדש, הוספה לסגמנט, או טריגר מתוזמן.",
  addNodeOnEdge:
    "הוסף שלב חדש בין שני צמתים קיימים — פעולה (שליחה, המתנה) או תנאי (פיצול לפי כלל).",
  selectTrigger:
    "בחר טריגר — האירוע שיפעיל את הג'ירני. כל ג'ירני מתחיל בטריגר אחד בלבד.",
  addActionNode:
    "פעולות — שלבים שמבוצעים על הליד: שליחת הודעה, המתנה, שאילתת SQL ועוד.",
  addConditionNode:
    "תנאים — מפצלים את הנתיב לפי כללים. ענף 'כן' ממשיך לפעולות, ענף 'לא' יכול להסתיים או להמשיך לפעולות אחרות.",
  sqlScheduleRequiresQuery:
    "כשהטריגר הוא SQL Schedule Trigger, השלב הבא חייב להיות SQL Query Action — שאילתה שמביאה את רשימת הלידים לעיבוד.",
  customQueryChoice:
    "בחר שאילתה שמורה מהספרייה, או צור שאילתה חדשה מאפס. שאילתות שמורות ניתנות לעריכה ושימוש חוזר בג'ירנים שונים.",
  saveQuery:
    "שמור את השאילתה לספריית השאילתות של המותג. כך תוכל להשתמש בה שוב בג'ירנים אחרים בלי לבנות מחדש.",
};

export const nodeTooltips = {
  stayedTimeOnPage:
    "מפעיל את הג'ירני כשמבקר נשאר בדף מסוים לזמן שמוגדר. מתאים לרימרקטינג או הצעות מיידיות למבקרים שלא המירו.",
  newLead:
    "מפעיל את הג'ירני כשנכנס ליד חדש למערכת. סנן לפי סוג ליד ומקור קמפיין iCreate כדי להפעיל רק על קהל רלוונטי.",
  abandonedCart:
    "מפעיל את הג'ירני כשלקוח עוזב עגלה עם מוצרים. שלח תזכורת או הצעה להשלמת הרכישה.",
  addedToSegment:
    "מפעיל את הג'ירני כשליד מתווסף לסגמנט (קהל) שבחרת. מתאים לקמפיינים ממוקדים לפי קהל מוגדר.",
  sqlScheduleTrigger:
    "מפעיל את הג'ירני לפי לוח זמנים (מיידי, חד-פעמי, חוזר, יומי או שבועי). חייב להיות מחובר ל-SQL Query Action כשלב הבא.",
  externalApi:
    "מפעיל את הג'ירני כשמערכת חיצונית שולחת בקשת API. מתאים לאינטגרציות עם אתרים, CRM או מערכות צד שלישי.",
  waitXTime:
    "ממתין זמן מוגדר לפני המשך הג'ירני. ניתן להגדיר דקות, שעות, ימים או תאריך ושעה מדויקים. שימושי לרצפי nurturing.",
  sqlQueryAction:
    "מריץ שאילתת SQL לבחירת לידים לעיבוד. הגדר תנאים, גודל batch, מגבלות גיל ליד ואפשרות שליחה חוזרת בימים שונים.",
  customNodeCommand:
    "תנאי מותאם אישית — בודק אם ליד עומד בשאילתת SQL. ענף Match ממשיך כשהליד נמצא בתוצאות, No Match כשלא.",
  conditionNode:
    "תנאי פשוט — בודק שדות מטבלת הלידים (סטטוס, מקור, opt-out ועוד). ענף Yes כשהתנאי מתקיים, No כשלא.",
  whatsappMessage:
    "שולח הודעת WhatsApp לליד לפי תבנית מאושרת. בחר תבנית, מפה placeholders לשדות מהליד.",
  emailMessage:
    "שולח אימייל לליד. בחר כתובת שולח, נושא ותבנית אימייל.",
  smsMessage:
    "שולח SMS לליד. בחר שם שולח (Sender ID) ותבנית הודעה.",
  sendToCrm:
    "שולח את פרטי הליד או עדכון ל-CRM חיצוני לפי הגדרות המותג.",
};

export const fieldTooltips = {
  "stayedTimeOnPage:timeUnit":
    "יחידת הזמן לחישוב שהמבקר נשאר בדף — דקות, שעות או ימים.",
  "stayedTimeOnPage:timeAmount":
    "כמה יחידות זמן המבקר חייב להישאר בדף לפני הפעלת הג'ירני.",
  "stayedTimeOnPage:sendTo":
    "כתובת או מזהה לשליחת ההודעה (למשל אימייל או טלפון) כשהתנאי מתקיים.",
  "stayedTimeOnPage:hoursToSkip":
    "טווח שעות שבו הג'ירני לא יופעל — למשל שעות לילה או שעות עבודה.",
  "stayedTimeOnPage:daysToSkip":
    "ימים בשבוע שבהם הג'ירני לא יופעל — למשל שבת וחגים.",

  "newLead:leadType":
    "סוג הליד שמפעיל את הג'ירני. ניתן לבחור מספר סוגים — הג'ירני יופעל על כל אחד מהם. לדוגמה: Facebook Ads, Click2Call, WhatsApp נכנס.",
  "newLead:campaignSource":
    "קמפיין iCreate שממנו הגיע הליד. הג'ירני יופעל רק על לידים מהקמפיינים שנבחרו.",

  "abandonedCart:cartItems":
    "קטגוריות מוצרים בעגלה. הג'ירני יופעל רק כשהעגלה מכילה מוצרים מהקטגוריות שנבחרו.",
  "abandonedCart:cartValue":
    "טווח ערך העגלה. סנן לפי סכום הרכישה הצפוי.",
  "abandonedCart:returningCustomer":
    "סמן אם הג'ירני מיועד רק ללקוחות חוזרים (כבר רכשו בעבר).",
  "abandonedCart:abandonmentTime":
    "כמה זמן עבר מאז שהלקוח עזב את העגלה לפני הפעלת הג'ירני.",

  "addedToSegment:segment":
    "הסגמנט (קהל) שכשליד מתווסף אליו — הג'ירני מופעל. ניתן לבחור מספר סגמנטים.",
  "addedToSegment:useSharedExit":
    "כשמופעל — כל הסגמנטים חולקים נקודת יציאה (Exit) משותפת. כשכבוי — לכל סגמנט יש ענף Exit נפרד.",

  "sqlScheduleTrigger:scheduleType":
    "סוג התזמון:\n• Immediate — הרצה מיידית\n• One Time — הרצה חד-פעמית בתאריך מוגדר\n• Recurring — חוזר כל X דקות/שעות/ימים\n• Daily — כל יום בשעה קבועה\n• Weekly — פעם בשבוע בשעה קבועה",
  "sqlScheduleTrigger:startDateTime":
    "תאריך ושעת התחלה — מתי הטריגר מתחיל לפעול (לתזמונים שאינם מיידיים).",
  "sqlScheduleTrigger:endDateTime":
    "תאריך ושעת סיום — מתי הטריגר מפסיק לפעול. חייב להיות אחרי תאריך ההתחלה.",
  "sqlScheduleTrigger:recurringEvery":
    "כל כמה יחידות זמן הטריגר חוזר (למשל כל 2 שעות).",
  "sqlScheduleTrigger:recurringUnit":
    "יחידת הזמן לחזרה — דקות, שעות או ימים.",
  "sqlScheduleTrigger:dailyTime":
    "שעת ההרצה היומית (פורמט 24 שעות).",
  "sqlScheduleTrigger:activeDays":
    "ימים בשבוע שבהם הטריגר פעיל. השאר ריק להרצה בכל הימים.",
  "sqlScheduleTrigger:weeklyTime":
    "שעת ההרצה השבועית (פורמט 24 שעות).",
  "sqlScheduleTrigger:timeZone":
    "אזור הזמן לחישוב התזמון. כרגע נתמך Asia/Jerusalem.",
  "sqlScheduleTrigger:isEnabled":
    "הפעל או השבת את הטריגר. כשכבוי — הג'ירני לא יורץ גם אם מוגדר תזמון.",

  "waitXTime:timeAmount":
    "משך ההמתנה לפני המשך לשלב הבא. לא רלוונטי כשבוחרים תאריך מדויק.",
  "waitXTime:timeUnit":
    "יחידת ההמתנה — דקות, שעות, ימים, או תאריך ושעה מדויקים (Exact Date).",
  "waitXTime:exactDateTime":
    "תאריך ושעה מדויקים להמשך הג'ירני — השלב הבא יופעל בזמן זה.",
  "waitXTime:daysToSkip":
    "ימים שבהם ההמתנה לא נספרת — למשל לא לספור שבת.",
  "waitXTime:hoursToSkip":
    "שעות שבהן ההמתנה לא נספרת — למשל מחוץ לשעות הפעילות.",

  "sqlQueryAction:batchSizePerRun":
    "מספר הלידים המקסימלי שמעובדים בכל הרצה. מונע עומס על המערכת בהרצות גדולות.",
  "sqlQueryAction:leadAgeRestriction":
    "מסנן לידים לפי תאריך השארת הפרטים. לידים חדשים מדי (לפי מספר הימים) לא ייכללו בשאילתה.",
  "sqlQueryAction:allowDuplicateSends":
    "כשמופעל — ליד שכבר קיבל שליחה יכול לקבל שוב ביום אחר. כשכבוי — כל ליד מעובד פעם אחת בלבד.",
  "sqlQueryAction:conditions":
    "שאילתת SQL ויזואלית לבחירת הלידים. הגדר טבלאות, שדות ותנאים. הרץ בדיקה לפני שמירה.",

  "customNodeCommand:conditions":
    "שאילתת SQL שבודקת אם הליד עומד בתנאים. לידים שמתאימים עוברים לענף Match.",
  "customNodeCommand:saveForReuse":
    "שמור את השאילתה לספרייה — תוכל להשתמש בה בג'ירנים אחרים של אותו מותג.",
  "customNodeCommand:queryName":
    "שם לשאילתה השמורה — יופיע בספריית השאילתות ובבחירת שאילתה קיימת.",

  "conditionNode:conditions":
    "תנאים על שדות הליד (סטטוס, מקור, opt-out ועוד). הליד עובר לענף Yes או No לפי התוצאה.",

  "whatsappMessage:template":
    "תבנית WhatsApp מאושרת לשליחה. התבנית חייבת להיות מאושרת על ידי Meta.",
  "emailMessage:sendFrom":
    "כתובת האימייל שממנה נשלח המייל — חייבת להיות מוגדרת ומאומתת במותג.",
  "emailMessage:subject":
    "נושא האימייל שיוצג בתיבת הדואר של הנמען.",
  "emailMessage:template":
    "תבנית האימייל — עיצוב ותוכן ההודעה.",
  "smsMessage:sendFrom":
    "שם השולח (Sender ID) שיוצג ב-SMS — חייב להיות רשום ומאושר.",
  "smsMessage:template":
    "תבנית ה-SMS — תוכן ההודעה עם placeholders אופציונליים.",
  "sendToCrm:sendFrom":
    "מקור השליחה ל-CRM — לפי הגדרות האינטגרציה.",
  "sendToCrm:template":
    "תבנית הנתונים שנשלחים ל-CRM.",
};

export const journeyCreationTooltips = {
  name: "שם הג'ירני — יופיע ברשימת הג'ירנים ויעזור לזהות את התהליך.",
  description: "תיאור קצר של מטרת הג'ירני — לשימוש פנימי של הצוות.",
  brandId: "המותג שאליו שייך הג'ירני. כל הגדרות התבניות, הסגמנטים והשאילתות תלויות במותג.",
  priority: "עדיפות הרצה — ג'ירנים בעדיפות גבוהה יקבלו משאבים לפני אחרים בעומס.",
  scheduleStart:
    "תאריך ושעת תחילת פעילות הג'ירני. לפני מועד זה הג'ירני לא יופעל.",
  scheduleEnd:
    "תאריך ושעת סיום (אופציונלי). אחרי מועד זה הג'ירני יפסיק לפעול אוטומטית.",
  status: "סטטוס הג'ירני — Pending = טרם פעיל, Active = פעיל, וכו'.",
};

export function getNodeTooltip(nodeType) {
  return nodeTooltips[nodeType] || "";
}

export function getFieldTooltip(nodeType, fieldId) {
  if (!nodeType || !fieldId) return "";
  return fieldTooltips[`${nodeType}:${fieldId}`] || "";
}

export function enrichFormFieldsWithTooltips(formFields, nodeType) {
  if (!formFields || !nodeType) return formFields;
  return formFields.map((field) => ({
    ...field,
    tooltip: field.tooltip || getFieldTooltip(nodeType, field.id),
  }));
}
